@if (this.attService.micPermissionError | async) {
<div
  class="ragai-mic-permission-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="mic-permission-title"
>
  <div class="ragai-mic-permission-content">
    <i
      class="ri-mic-off-line ragai-mic-permission-icon"
      aria-hidden="true"
    ></i>
    <h3
      id="mic-permission-title"
      i18n="@@mic-permission-title"
    >Mikrofon nicht verfügbar</h3>
    <p
      class="ragai-mic-permission-description"
      i18n="@@mic-permission-error"
    >
      Dein Mikrofon konnte nicht erkannt werden. Prüfe, ob es angeschlossen und freigegeben ist, und lade die Seite neu.
    </p>
    <div class="ragai-mic-permission-hint">
      <span i18n="@@mic-permission-hint">Achte auf die Berechtigungsanfrage oben in deinem Browser und erlaube den
        Mikrofonzugriff.</span>
    </div>
    <button
      type="button"
      class="ragai-mic-permission-btn"
      (click)="this.reload()"
    >
      <span aria-hidden="true">↻</span>
      <span i18n="@@dc-overlay-default-continue">Seite neu laden</span>
    </button>
  </div>
</div>
}